import { i18n } from "@/shared/config/i18n";
import { ApiError } from "./errors";

/** Friendly copy for an error code, falling back to the text the server (or a client check) provided. */
export function friendlyMessage(code: string, fallback: string): string {
  const key = `errors.${code}`;
  return i18n.exists(key) ? i18n.t(key) : fallback;
}

/** Message for any error, with the request id appended so it can be quoted to support. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const message = friendlyMessage(error.code, error.message);
    return error.requestId
      ? i18n.t("errors.withRef", { message, requestId: error.requestId })
      : message;
  }
  return i18n.t("errors.UNKNOWN");
}
